import { ConstructorArgs } from '../types/models'
import { BaseRecord } from './BaseRecord'
import { Item } from './Item'

export type ItemComponentConstructorArgs = ConstructorArgs<() => ItemComponent>

export class ItemComponent extends BaseRecord {
    readonly recordType = 'itemcomponent'

    capacity?: number

    constructor(data?: Partial<ItemComponentConstructorArgs>) {
        super(data)
        if (!data) {
            return
        }

        this.capacity = this.propertyFromIntArg(data.capacity)
    }

    clone(overrides?: Partial<ItemComponentConstructorArgs>): ItemComponent {
        return new ItemComponent({ ...this.serializeForClone(), ...overrides })
    }

    static initWithItem(item: Item): ItemComponent {
        const component = new ItemComponent()
        component.component = item
        return component
    }

    deserialize(data: any) {
        super.deserialize(data)

        if (data.component) this.component = BaseRecord.fromSerializer(data.component, Item)
        if (data.item) this.item = BaseRecord.fromSerializer(data.item, Item)
    }

    jsonObject(): any {
        const dict = super.jsonObject()
        dict['capacity'] = this.capacity ?? ''
        dict['component'] = this.component?.id ?? ''
        return dict
    }

    get item(): Item | undefined {
        return this.getForeignRecord('item', Item)
    }
    set item(item: Item | undefined) {
        this.setForeignRecord('item', item)
    }
    get component(): Item | undefined {
        return this.getForeignRecord('component', Item)
    }
    set component(component: Item | undefined) {
        this.setForeignRecord('component', component)
    }
}
